
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PostDetailComponent } from './post-detail.component';
import { PostDetailRoutingModule } from './post-detail-routing.module';
import { RouterModule } from '@angular/router';
import { LatestPostModule } from 'src/app/components/latestPosts/latest-post.module';


@NgModule({
    declarations: [
        PostDetailComponent,
    ],
    imports: [
        CommonModule,
        LazyLoadImageModule,
        PostDetailRoutingModule,
        RouterModule,
        LatestPostModule
    ]
})
export class PostDetailModule { }


